import React from 'react';
import { PageHero } from '../components/PageHero';
import { ConsultantList } from '../components/ConsultantList';
import { CtaBand } from '../components/CtaBand';
export function Consultants() {
  return <>
      <PageHero breadcrumb="Our Consultants" title="Our executive search team." lead="Every mandate is led personally by a member of our team — from the first conversation through a new leader’s first year in role." data-id="element-249" data-mp="yad9z154hr1m" />
      <section className="bg-ivory" data-id="element-250" data-mp="pcjfzwutz9hm">
        <div className="mx-auto max-w-site px-6 py-20 lg:px-10 lg:py-28" data-id="element-251" data-mp="kjq6ywsbxezq">
          <ConsultantList data-id="element-252" data-mp="fknf6e1d159p" />
          <p className="mt-16 max-w-2xl text-[15px] leading-relaxed text-midnight-900/65" data-id="element-253" data-mp="flyi6bmze8zr">
            Prefer not to write to an individual? Use our confidential inquiry form and we’ll route your message to the right
            consultant.
          </p>
        </div>
      </section>
      <CtaBand data-id="element-254" data-mp="1km3e3jk4dfg" />
    </>;
}